import { render, staticRenderFns } from "./VoerroTagsInput.vue?vue&type=template&id=3cc037a2&"
import script from "./VoerroTagsInput.vue?vue&type=script&lang=js&"
export * from "./VoerroTagsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports